import { isDobWithinAgeRange } from "./formatters";

/** Annuitants with "Other"/"Others" gender must be 30 to 45 years 364 days old. */
export const GENDER_RESTRICTED_MIN_AGE = 30;
export const GENDER_RESTRICTED_MAX_AGE = 45;
export const GENDER_RESTRICTED_AGE_ERROR = `Age must be between ${GENDER_RESTRICTED_MIN_AGE} and ${GENDER_RESTRICTED_MAX_AGE} years for the selected gender.`;

const RESTRICTED_GENDER_PATTERN = /^(others?|trans)/i;
// Liferay DDM option code for "Other" (see premiumService.normalizeGender).
const OTHER_GENDER_OPTION_CODE = "option92959134";

const optionLabel = (opt) => {
  const label = opt?.label;
  if (label && typeof label === "object") return String(label.en_US ?? "");
  return String(label ?? "");
};

/**
 * True for "Other" / "Others" / "Trans…" gender. `field` is optional; when
 * given, a stored option value/reference (e.g. "Option123") is resolved to
 * its label before matching.
 */
export const isGenderRestricted = (value, field) => {
  const raw = String(value ?? "").trim();
  if (!raw) return false;
  if (RESTRICTED_GENDER_PATTERN.test(raw)) return true;
  const lower = raw.toLowerCase();
  if (lower === "o" || lower.includes(OTHER_GENDER_OPTION_CODE)) return true;
  const option = (field?.options || []).find(
    (opt) =>
      opt &&
      typeof opt === "object" &&
      [opt.value, opt.reference].some((v) => String(v ?? "").trim() === raw),
  );
  return option ? RESTRICTED_GENDER_PATTERN.test(optionLabel(option).trim()) : false;
};

/** @param {string} isoDob - YYYY-MM-DD */
export const isWithinGenderRestrictedAge = (isoDob) =>
  isDobWithinAgeRange(String(isoDob ?? "").trim(), {
    minAge: GENDER_RESTRICTED_MIN_AGE,
    maxAge: GENDER_RESTRICTED_MAX_AGE,
  });

/** True when gender is restricted and the DOB falls outside 30–45y364d. */
export const violatesGenderRestrictedAge = (gender, dob, genderField) =>
  isGenderRestricted(gender, genderField) &&
  Boolean(String(dob ?? "").trim()) &&
  !isWithinGenderRestrictedAge(dob);
